<template>
  <b-card no-body>
    <b-overlay :show="blockAllInputs && !is_backup">
      <b-container fluid class="mt-3">
        <b-row
          v-for="(row, index) in document.document_template.rows"
          :key="'doc-row-' + index"
          style="background-color: rgb(235, 235, 235)"
          class="pb-0"
        >
          <b-col
            v-for="(field, index2) in row.fields"
            :key="'doc-row-' + index + '-field-' + index2"
            cols="12"
            :md="field.size"
            class="custom-col p-0 m-0 text-left"
            :class="'content-' + field.style + (!field.key ? ' pl-1' : '')"
          >
            <div
              v-if="field.style === 1 && field.key && field.kind === 1"
              class="form-group w-100 mb-0 h-100 text-bottom"
              style="display: table"
            >
              <div
                :id="field.key + '-wrapper'"
                style="display: table-cell"
                class="align-bottom"
              >
                <label
                  v-if="field.name"
                  class="ml-1"
                  :for="field.key"
                  style="font-size: 0.9vw"
                  >{{ field.name }}</label
                >
                <b-form-textarea
                  class="form-control"
                  no-resize
                  :id="field.key"
                  @focus="blockInput(field.key)"
                  @blur="customUnblock(field.key, field_values[field.key])"
                  :disabled="
                    blockedInputs.includes(field.key) || blockAllInputs
                  "
                  :formatter="getFormatter(field.max_length)"
                  v-model="field_values[field.key]"
                  :state="
                    field_values[field.key] &&
                    field_values[field.key].length <= field.max_length &&
                    field_values[field.key].length > 0
                  "
                  data-toggle="popover"
                />
              </div>
              <b-tooltip
                v-if="blockedInputs.includes(field.key)"
                :target="field.key + '-wrapper'"
                triggers="hover"
              >
                {{ blockedInputsUsers[blockedInputs.indexOf(field.key)] }} está
                escribiendo en este campo.
              </b-tooltip>
            </div>
            <b-form-checkbox
              class="ml-2 mb-1"
              v-if="field.style === 1 && field.key && field.kind === 2"
              :id="field.key"
              @change="customUnblock(field.key, field_values[field.key])"
              :disabled="blockedInputs.includes(field.key) || blockAllInputs"
              v-model="field_values[field.key]"
              :name="field.key"
              :value="true"
              :unchecked-value="''"
            />
            <label
              v-if="
                field.style === 1 && field.key && field.kind === 2 && field.name
              "
              style="font-size: 1vw"
              :for="field.key"
              >{{ field.name }}</label
            >
            <span
              v-if="field.style === 1 && !field.key"
              style="font-size: 0.9vw"
            >
              {{ field.text }}
            </span>
            <h6 v-if="field.style !== 1" style="font-size: 1vw">
              <strong>
                {{ field.text }}
              </strong>
            </h6>
            <!-- <h6 v-if="field.style === 3">
          {{field.text}}
        </h6>
        <h6 v-if="field.style === 4">
          {{field.text}}
        </h6>
        <h6 v-if="field.style === 5">
          {{field.text}}
        </h6> -->
          </b-col>
        </b-row>
      </b-container>
      <template #overlay>
        <div class="text-center">
          <p v-if="blockAllInputs" id="cancel-label">
            Recarga el sitio para voler a conectarte.
          </p>
        </div>
      </template>
    </b-overlay>
  </b-card>
</template>
<script>
import documentSocket from "../../../mixins/documentSocket";
import redpieService from "../../../services/redpieService";

export default {
  props: {
    document: {
      type: Object,
      required: true,
    },
    leave: {
      type: Boolean,
      required: false,
    },
    is_backup: {
      type: Boolean,
      required: false,
    },
    // Chatbot (studentless) mode: the documentSocket mixin skips all
    // socket/ping/persistence, answers stay in the local field_values only.
    localMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [documentSocket],
  watch: {
    leave() {
      if (this.leave) {
        this.leaveDocument();
      }
    },
    fillableFields() {
      this.$emit("fields", this.fillableFields);
    },
  },
  data() {
    return {
      retrievedContext: [],
      extraEvents: {},
      touchedFields: [],
      actualContext: {},
    };
  },
  created() {
    this.field_values = this.document.context;
    this.touchedFields = [];
    // this.checkAutoUpdateFureev();
    this.$store.dispatch("setFieldValues", this.field_values);
    if (!this.is_backup) {
      this.joinDocument(this.document.id);
      this.getFureevContext();
    }
  },
  methods: {
    getFureevContext() {
      redpieService
        .getFureevContext({ document: this.document.id })
        .then((data) => {
          this.actualContext = data;
        });
    },
    customUnblock(key, value) {
      this.touchedFields.push(key);
      this.unblockInput(key, value);
    },
    getFormatter: function (maxLen) {
      if (maxLen) return (text) => String(text).substring(0, maxLen);
      else return (text) => text;
    },
    manualSave: function () {
      var customFields = {};
      this.touchedFields.forEach((key) => {
        customFields[key] = this.field_values[key];
      });
      redpieService
        .manualSaveFureev({
          fields: customFields,
          document: this.document.id,
        })
        .then((data) => {
          this.$toasted.success(data.message);
        });
    },
    checkAutoUpdateFureev: function () {
      redpieService
        .checkAutoUpdateFureev({
          document: this.document.id,
        })
        .then((data) => {
          this.retrievedContext = data;
        });
    },
  },
  computed: {
    fillableFields() {
      var fields = [];
      this.document.document_template.rows.forEach((row) => {
        row.fields.forEach((field) => {
          if (
            (this.field_values[field.key] === "" ||
              !this.field_values[field.key]) &&
            Object.keys(this.actualContext).includes(field.key)
          ) {
            fields.push(field.name);
          }
        });
      });
      return fields;
    },
  },
};
</script>
<style lang="scss">
.custom-col {
  border: 1px black solid !important;
  min-height: 38px !important;
}
.content-1 {
  overflow-wrap: break-word !important;
  justify-content: flex-start !important;
}
.content-2 {
  overflow-wrap: break-word !important;
  padding-left: 10px !important;
  background-color: rgb(155, 187, 89) !important;
  justify-content: flex-start !important;
}
.content-3 {
  overflow-wrap: break-word !important;
  padding-left: 10px !important;
  background-color: rgb(214, 227, 188) !important;
  justify-content: flex-start !important;
}
.content-4 {
  overflow-wrap: break-word !important;
  padding-left: 10px !important;
  background-color: rgb(234, 241, 221) !important;
  justify-content: flex-start !important;
}
.content-5 {
  overflow-wrap: break-word !important;
  padding-left: 10px !important;
  background-color: rgb(234, 241, 221) !important;
  justify-content: flex-start !important;
}
</style>
